// File: /src/components/dashboard/AgendaPanel.js

import React from 'react';
import { format } from 'date-fns';
import { ptBR } from 'date-fns/locale';
import { FaCalendar, FaChevronLeft, FaChevronRight } from 'react-icons/fa';

const AgendaPanel = ({
	selectedDate,
	setToday,
	goToPreviousDay,
	goToNextDay,
	loadingEvents,
	dayEvents,
}) => (
	<div className="agenda-container">
		<div className="agenda-header">
			<div className="card-icon">
				<FaCalendar size={16} />
			</div>
			<h2>Agenda do Dia</h2>
		</div>
		<div className="agenda-nav">
			<button onClick={goToPreviousDay} className="nav-button">
				<FaChevronLeft />
			</button>
			<button onClick={setToday} className="today-button">
				Hoje
			</button>
			<button onClick={goToNextDay} className="nav-button">
				<FaChevronRight />
			</button>
		</div>
		<div className="selected-date">
			{format(selectedDate, "dd 'de' MMMM 'de' yyyy", { locale: ptBR })}
		</div>

		<div className="agenda-content">
			{loadingEvents ? (
				<p>Carregando eventos...</p>
			) : dayEvents.length > 0 ? (
				<ul className="events-list">
					{dayEvents.map((event, index) => (
						<li key={index} className={`event-item ${event.type}`}>
							<span className="event-time">
								{format(new Date(event.start), 'HH:mm')}
							</span>
							<span className="event-title">{event.title}</span>
							<span className={`event-type ${event.type}`}>
								{event.type === 'project' && 'Projeto'}
								{event.type === 'invoice' && 'Fatura'}
								{event.type === 'calendar' && 'Evento'}
							</span>
						</li>
					))}
				</ul>
			) : (
				<p className="no-events">Nenhum evento para este dia</p>
			)}
		</div>
	</div>
);

export default AgendaPanel;
